import { Mixins, Component } from 'vue-property-decorator';
import DataMixin from '@/components/product/ProductPopSearchDataMixin';
import {NewDisplayEnum, CategroyType} from '@/types/product';
import { Brand, BrandsView,  GetBrandsViewRequest, Mall, NCPResponse, Nullable } from 'supporter';
import {gridModelToExcel} from '@/utils/ncp';
import {writeExcel} from '@/utils/excel';
import {getDownToday} from '@/utils/dateUtils';
import {escapeHtml, getCurrency, getProductsConfigurationsByAllMall} from '@/utils/commonUtils';
import debounce from 'lodash.debounce';
const set = require('lodash.set');
import { camelCase } from 'lodash'
@Component
export default class ProductPopSearchMethodsMixin extends Mixins(DataMixin) {
  public get currentMallName(): string {
    const mall = this.mallInfo.find((mall: Mall): boolean => mall.mallNo + '' === this.routeQuery.mallNo);
    if (mall) {
      return mall.mallName;
    }
    return '';
  }

  public get displayCategoryNos(): number[] {
    const displayCategoryNos = this.$route.query['displayCategoryNos'];
    if (displayCategoryNos) {
      if (Array.isArray(displayCategoryNos)) {
        return displayCategoryNos.map((item: string): number => Number(item));
      } else {
        return [Number(displayCategoryNos)];
      }
    } else {
      return [];
    }
  }

  public initPop(popInfo: any): void {
    this.setPopInfo(popInfo);
    this.setPopIsShow(true);
  }

  public showProductManagementCdLikeGuide(): void {
    this.initPop(this.popInfo);
  }

  public keywordInfoChange(): void {
    const keywordInfoType = this.searchParams['keywordInfo.type'];
    if (keywordInfoType === 'PRODUCT_MANAGEMENT_CD_LIKE') {
      this.keywordTexthide = false;
    } else {
      this.keywordTexthide = true;
    }
  }

  //****************************************
  //searchMenu related definition start
  public searchMenuBlur(elName: any): void {
    if (elName === 'brand' && this.searchParams['brandNo'] === -100) {
      this.brandsInputVal = '';
    } else if (elName === 'partner' && this.searchParams['partnerNo'] === -100) {
      this.partnerInputVal = '';
    } else if (elName === 'admin' && this.searchParams['adminNo'] === -100) {
      this.adminInputVal = '';
    }
  }

  public searchMenuFocus(elName: any, event: any): void {
    if (!this.searchParams.mallNos) {
      event.currentTarget.blur();
      alert(this.ALERT_MESSAGES.chooseMall);
    } else {
      if (elName === 'brand' && this.brandsInputVal.length) {
        this.brandsMenuIsShow = true;
      }

      if (elName === 'partner' && this.partnerInputVal.length) {
        this.partnerMenuIsShow = true;
      }

      if (elName === 'admin' && this.adminInputVal.length) {
        this.adminMenuIsShow = true;
      }
    }
  }

  private searchBrand = debounce((e:Event) => this.searchBrandsByKeyword(e), 500);
  private async searchBrandsByKeyword(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    const isSelectedBrand = !this.brandsMenuIsShow;
    if (!value || isSelectedBrand) return;

    this.brandsInputVal = value;
    this.fetchBrandsSearch(value);
  }

  private addSubBrandName(mainBrandName: Nullable<string>, subBrandName: Nullable<string>):string {
    return !!subBrandName ? `${mainBrandName}(${subBrandName})` : mainBrandName;
  }

  private convertBrandName(depthBrand: BrandsView):string {
    const initialMaxDepth = [...Array(3).keys()]?.map(index => ({[(index+1).toString()]: null}))
    
    const convertBrandInfo = Object.entries(depthBrand).reduce((acc, [key, value]) => {
      const matchedDepth = key.match(/^depth(\d+)(Name|SubName)$/);
      if(matchedDepth){
        const depth = matchedDepth[1];
        acc[depth] = {...acc[depth], [camelCase(matchedDepth[2])]: value};
      }
      return acc;
    }, initialMaxDepth);

    const fetchBrandFullName = Object.entries(convertBrandInfo)
      .filter(([_, value]) => !!value?.name)
      .map(([_, { name, subName}]) => this.addSubBrandName(name, subName)).join(' > ');


    return fetchBrandFullName;
  }

  private convertBrandsList(brandsList: BrandsView[], mallNo: number): Brand[] {
    return brandsList.map((item: BrandsView): Brand => {


      return {
        brandName: this.convertBrandName(item),
        displayBrandNo: item.lastDepthBrandNo,
        brandNo: item.lastDepthBrandNo,
        mallNo
      };
    });
    
  }

  private async fetchBrandsSearch(value: string) {
    if(value?.length < 2) return;

    const mallNo =  Number(this.routeQuery['mallNo']);
    if (!mallNo || !value.length ) return;

    const params: GetBrandsViewRequest = { params: { mallNo, brandName: value } };
    const { data }: NCPResponse<BrandsView[]> = await this.$api.getBrandsView(params);
    

    this.brandsList = this.convertBrandsList(data, mallNo);
  }

  public searchMenuInput(elName: any, event:Event): void {
    if (elName === 'brand') {
      this.brandsList = [];
      this.searchBrand(event);
      this.brandsMenuIsShow = true;
      this.searchParams['brandNo'] = -100;
    } else if (elName === 'partner') {
      if (!this.partnerList.length) {
        this.$api.getMallsContractedPartnersByMallNo({pathParams: {mallNo: this.searchParams.mallNos}}).then(({data}): void => {
          this.partnerList = data.filter(item => {
            return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
          });
          this.partnerMenuIsShow = true;
        });
      } else {
        this.partnerMenuIsShow = true;
      }

      this.searchParams['partnerNo'] = -100;
    } else if (elName === 'admin') {
      if (!this.adminList.length) {
        this.$api.getAdminsServiceMerchandisers({params: {mallNo: this.searchParams.mallNos}}).then(({data}): void => {
          this.adminList = data;
          this.adminMenuIsShow = true;
        });
      } else {
        this.adminMenuIsShow = true;
      }

      this.searchParams['adminNo'] = -100;
    }
  }

  public searchMenuSelected(valueName: 'adminNo' | 'brandNo' | 'partnerNo', item: NewDisplayEnum): void {
    this.searchParams[valueName] = Number(item.value);
    if (valueName === 'adminNo') {
      this.adminInputVal = item.text;
      this.adminMenuIsShow = false;
    } else if (valueName === 'brandNo') {
      this.brandsInputVal = item.text;
      this.brandsMenuIsShow = false;
    } else if (valueName === 'partnerNo') {
      this.partnerInputVal = item.text;
      this.partnerMenuIsShow = false;
    }
  }

  public adminSearchMenuClose(): void {
    this.adminMenuIsShow = false;
  }
  public brandsSearchMenuClose(): void {
    this.brandsMenuIsShow = false;
  }
  public partnerSearchMenuClose(): void {
    this.partnerMenuIsShow = false;
  }
  //searchMenu menu related definition end
  //****************************************

  public applyStatusTypeChange(): void {
    const applyStatusType = this.searchParams['applyStatusType'];
    switch (applyStatusType) {
      case 'REGISTRATION_READY':
      case 'APPROVAL_READY':
      case 'APPROVAL_REJECTION':
      case 'SALE_AGREEMENT_READY':
      case 'SALE_AGREEMENT_REJECTION':
        this.initSaleStatus(true, false);
        break;
      case 'ALL':
      case 'FINISHED':
      case 'AFTER_APPROVAL_READY':
      case 'AFTER_APPROVAL_REJECTION':
        this.initSaleStatus(false, false);
        break;
    }
  }

  public commissionTypeChange(): void {
    this.isSupplyPriceViewShow = false;
    this.isCommissionRateView = false;
    const commissionType = this.searchParams['commission.type'];
    switch (commissionType) {
      case 'RATE':
        this.isCommissionRateView = true;
        break;
      case 'SUPPLY_PRICE':
        this.isSupplyPriceViewShow = true;
        break;
    }
  }

  public cateCascadeTypeChange(categoryObj: any): void {
    Object.assign(this.searchParams, categoryObj);
  }

  public stockRangeChange(range: any): void {
    switch (range) {
      case '0':
        this.searchParams['stockRange.type'] = 'NONE';
        this.searchParams['stockRange.stockCnt'] = 0;
        break;
      case '1':
        this.searchParams['stockRange.type'] = 'EXIST';
        this.searchParams['stockRange.stockCnt'] = 1;
        break;
      case '5':
      case '10':
      case '50':
      case '100':
        this.searchParams['stockRange.type'] = 'LE';
        this.searchParams['stockRange.stockCnt'] = Number(range);
        break;
      default:
        this.searchParams['stockRange.type'] = 'ALL';
        delete this.searchParams['stockRange.stockCnt'];
        break;
    }
  }

  public saleMethodTypeChange(): void {
    const saleMethodType = this.searchParams['saleMethodType'];
    if (saleMethodType === 'PURCHASE') {
      this.isCommissionTypeDisabled = true;
    } else {
      this.isCommissionTypeDisabled = false;
    }
  }

  public fireExcelDown(): void {
    const data = this.searchRespones.contents || [];
    if (data.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      // const model = gridModelToExcel(this.gridProps.columns);
      const model = gridModelToExcel(this.excelColumns);
      model.formatter['mallProductNo'] = ({value}: any): string => {
        return value;
      };
      model.formatter['productName'] = ({value}: any): string => {
        return escapeHtml(value);
      };
      model.formatter['commissionRate'] = ({row}: any): string => {
        if (row.saleMethodType === 'PURCHASE' || row.commission.type === 'PURCHASE_PRICE') {
          return '-';
        }
        return `${row.commission.rate}%`;
      };
      // model.formatter['supplyPrice'] = ({value, row}: any): string => {
      //   if (row.saleMethodType === 'PURCHASE') {
      //     return '-';
      //   }
      //   return getCurrency(value, this.USMallNos.includes(row.mallNo));
      // };
      // model.formatter['purchasePrice'] = ({row}: any): string => {
      //   if (row.saleMethodType === 'CONSIGNMENT') {
      //     return '-';
      //   }
      //   return getCurrency(row.supplyPrice, this.USMallNos.includes(row.mallNo));
      // };
      model.formatter['applyStatusType'] = ({row}: any): any => {
        let text = '';
        switch (row.applyStatusType) {
          case 'REGISTRATION_READY':
            text = this.toI18n('MWAITING_FOR_REGISTRATION'); //등록대기
            break;
          case 'APPROVAL_READY':
            text = this.toI18n('MWAITING_FOR_APPROVAL'); //승인대기
            break;
          case 'APPROVAL_REJECTION':
            text = this.toI18n('MREJECTION_OF_APPROVAL'); //승인거부
            break;
          case 'SALE_AGREEMENT_READY':
            text = this.toI18n('MWAITING_FOR_SALES_AGREEMENT'); //판매합의대기
            break;
          case 'SALE_AGREEMENT_REJECTION':
            text = this.toI18n('MREJECTION_OF_SALES_AGREEMENT'); //판매합의거부
            break;
          case 'AFTER_APPROVAL_READY':
            text = this.toI18n('MWAITING_FOR_APPROVAL_AFTER'); //수정 후 승인대기
            break;
          case 'AFTER_APPROVAL_REJECTION':
            text = this.toI18n('MREJECT_APPROVAL_AFTER'); //수정 후 승인거부
            break;
          default:
            return this.toI18n('MAPPROVAL_COMPLETED'); //승인완료
            break;
        }

        return text;
      };
      model.formatter['saleStatusType'] = ({value}: any): string => {
        switch (value) {
          case 'PRE_APPROVAL_STATUS':
            return '-';
          case 'ON_PRE_SALE':
            return this.toI18n('MPRE_ORDER'); //예약판매중
          case 'WAITING_SALE':
            return this.toI18n('MWAITING_FOR_SALE'); //판매대기
          case 'ON_SALE':
            return this.toI18n('MSALE'); //판매중
          case 'END_SALE':
            return this.toI18n('MEND_OF_SALE'); //판매종료
          default:
            return '';
        }
      };
      model.formatter['saleSettingStatusType'] = ({value}: any): string => {
        switch (value) {
          case 'AVAILABLE_FOR_SALE':
            return this.toI18n('MAVAILABLE_FOR_SALE'); //판매가능
          case 'STOP_SELLING':
            return this.toI18n('MSTOP_SELLING'); //판매중지
          case 'PROHIBITION_SALE':
            return this.toI18n('MPROHIBITION_OF_SALE'); //판매금지
          default:
            return '';
        }
      };
      model.formatter['frontDisplayable'] = ({value}: any): string => {
        const val = String(value);
        let text = '';
        switch (val) {
          case 'true':
            text = this.toI18n('MDISPLAY_POSSIBLE'); //전시가능
            break;
          case 'false':
            text = this.toI18n('MNO_EXHIBITION'); //전시안함
            break;
        }
        return text;
      };
      // model.formatter['reservationPeriod'] = ({value}: any): string => {
      //   if (value && value.startYmdt && value.endYmdt) {
      //     return `${value.startYmdt} ~ ${value.endYmdt}`;
      //   } else {
      //     return '-';
      //   }
      // };
      model.formatter['appliedImmediateDiscountPrice'] = ({value, row}: any): string => {
        const val = getCurrency(value, row.countryCd === 'US');
        if (parseInt(val, 10) <= 0) {
          return '0';
        }
        return val;
      };
      model.formatter['appliedAdditionalDiscountPrice'] = ({value, row}: any): string => {
        const val = getCurrency(value, row.countryCd === 'US');
        if (parseInt(val, 10) <= 0) {
          return '0';
        }
        return val;
      };
      model.formatter['stockCnt'] = ({row}: any): string => {
        // return row.productStock.safetyStockCnt;
        return this.getStockCntColumnValue(row.productStock.representCnt, row.productStock.safetyStockCnt, row.optionType, row.isSoldOut);
      };
      model.formatter['promotionYn'] = ({value, row}: any): string => {
        if (row.applyStatusType === 'REGISTRATION_READY') {
          return '-';
        }

        if (row.saleStatusType === 'REGISTRATION_READY' || row.saleSettingStatusType === 'PROHIBITION_SALE') {
          return value;
        }

        return value;
      };
      model.formatter['displayCategoryNames'] = ({value}: any): any => {
        if (!value) {
          return '';
        }
        return value.join('|');
      };

      const excelColumn: any = {};
      this.excelColumns.forEach((column: any): void => {
        excelColumn[column.name] = column.header;
      });

      const filename = 'product_' + getDownToday();
      writeExcel(data, excelColumn, filename, model.formatter);
    }
  }

  public setSaleStatus(): void {
    const saleStatus = this.$refs.saleStatus as any;
    const {allCheckedStatusList, allStatusCheck, allSettingCheck} = saleStatus;

    const saleStatusObj = {
      'saleStatus.isAll': allStatusCheck,
      'saleSettingStatus.isAll': allSettingCheck,
      'saleStatus.types': '',
      'saleSettingStatus.types': ''
    };
    const saleStatusTypes: {[propName: string]: any} = {};
    const saleSettingStatusTypes: {[propName: string]: any} = {};

    allCheckedStatusList.forEach((status: string): void => {
      switch (status) {
        case 'WAITING_SALE':
          saleStatusTypes.WAITING_SALE = 1;
          break;
        case 'ON_SALE':
          saleStatusTypes.ON_SALE = 1;
          break;
        case 'END_SALE':
          saleStatusTypes.END_SALE = 1;
          break;
        case 'STOP_SELLING':
          saleSettingStatusTypes.STOP_SELLING = 1;
          break;
        case 'PROHIBITION_SALE':
          saleSettingStatusTypes.PROHIBITION_SALE = 1;
          break;
        case 'ON_PRE_SALE':
          saleStatusTypes.ON_PRE_SALE = 1;
          break;
        case 'AVAILABLE_FOR_SALE':
          saleSettingStatusTypes.AVAILABLE_FOR_SALE = 1;
          break;
      }
    });

    saleStatusObj['saleSettingStatus.types'] = Object.keys(saleSettingStatusTypes).join();
    saleStatusObj['saleStatus.types'] = Object.keys(saleStatusTypes).join();

    Object.assign(this.searchParams, saleStatusObj);
  }

  public resetData(page: number, size: number): void {
    if (size) {
      this.searchParams.size = size;
    }
    this.search(page);
  }

  public search(page: number = 1, isAllSave: boolean = false): void {
    this.setSaleStatus();
    this.$nextTick((): void => {
      const params: {[propName: string]: any} = {};
      Object.keys(this.searchParams).forEach((prop: any): void => {
        if (this.searchParams[prop] !== -100 && this.searchParams[prop] !== '') {
          Object.assign(params, {[prop]: this.searchParams[prop]});
        }
      });


      // 해당 부분 필요없어 보임
      // if (this.routeQuery.callBackName && this.routeQuery.callbackParam === 'remove') {
      //   const keywordInfoType = 'MALL_PRODUCT_NO';
      //   let keywordInfoKeywords = JSON.parse(window.localStorage.productPriorityProductNos).join();
      //   if(this.searchParams['keywordInfo.keywords'].length){
      //     keywordInfoKeywords = keywordInfoKeywords.split(',').filter(keyword=>this.searchParams['keywordInfo.keywords'].includes(keyword)).toString();
      //     Object.assign(params, {'keywordInfo.type': keywordInfoType, 'keywordInfo.keywords': keywordInfoKeywords});
      //   }else{
      //     Object.assign(params, {'keywordInfo.type': keywordInfoType, 'keywordInfo.keywords': keywordInfoKeywords});
      //   }
      //   // Object.assign(this.searchParams, {'keywordInfo.type': keywordInfoType, 'keywordInfo.keywords': keywordInfoKeywords});
      // }

      let exceptedNos = localStorage.getItem('productPrioriytExceptedNos');
      if (exceptedNos && this.routeQuery.callbackParam === 'add') {
        const exceptedMallProductNos = JSON.parse(exceptedNos);
        if (Array.isArray(exceptedMallProductNos) && exceptedMallProductNos.length) {
          Object.assign(params, {exceptedMallProductNos: exceptedMallProductNos.map((item: any): number => Number(item))});
        }
      }

      exceptedNos = localStorage.getItem('exceptedNos');
      if (exceptedNos) {
        const exceptedMallProductNos = JSON.parse(exceptedNos);
        if (Array.isArray(exceptedMallProductNos)) {
          Object.assign(params, {exceptedMallProductNos: exceptedMallProductNos.map((item: any): number => Number(item))});
        }
      }

      if (this.routeQuery.couponTarget === 'true') {
        Object.assign(params, {canApplyCoupon: 'Y'});
      }
      if (this.routeQuery.additionalDiscount === 'true') {
        Object.assign(params, {canApplyAdditionalDiscount: 'Y'});
      }
      Object.assign(params, {page});

      if (this.searchParams['saleStatus.isAll']) {
        delete params['saleStatus.types'];
      }

      if (!this.searchParams['saleStatus.types']) {
        delete params['saleStatus.isAll'];
        delete params['saleStatus.types'];
      }

      if (this.searchParams['saleSettingStatus.isAll']) {
        delete params['saleSettingStatus.types'];
      }

      if (!this.searchParams['saleSettingStatus.types']) {
        delete params['saleSettingStatus.isAll'];
        delete params['saleSettingStatus.types'];
      }

      let keywords = params['keywordInfo.keywords'] || '';
      this.invalidKeywordClass = '';
      if (params['keywordInfo.type'] === 'MALL_PRODUCT_NO') {
        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        keywords = keywords.map((el: any): void => el.trim());
        let flag = false;
        flag = keywords.some((v: any): boolean => {
          return /^\d+$/.test(v) === false;
        });
        if (flag) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.toI18n('MYOU_CAN_ONLY_ENTER_NUMBERS'); //숫자와 콤마만 입력할 수 있습니다
          this.invalidKeywordClass = 'validation_fail_target';
          return;
        }

        flag = keywords.some((v: any): boolean => {
          return /^\d+$/.test(v) && v.length > 10;
        });
        if (flag) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.toI18n('KEYWORDS_LENGTH_MORETHEN'); //상품 번호는 10자 이하로 입력할 수 있습니다.
          this.invalidKeywordClass = 'validation_fail_target';
          return;
        }

        params['keywordInfo.keywords'] = keywords.join(',');
      } else if (params['keywordInfo.type'] === 'PRODUCT_NAME') {
        if (/^\d{9}$/.test(keywords)) {
          params['keywordInfo.type'] = 'MALL_PRODUCT_NO';
        }
      } else if (params['keywordInfo.type'] === 'PRODUCT_MANAGEMENT_CD') {
        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        params['keywordInfo.keywords'] = keywords.join(',');
      }

      if (params['mallNos']) {
        Object.assign(params, {mallNos: params['mallNos'].split(',').map((item: any): number => Number(item))});
      }

      const newParams = {};
      Object.keys(params).forEach((v: any): void => {
        set(newParams, v, params[v]);
      });
      if (newParams['keywordInfo']['keywords']) {
        Object.assign(newParams['keywordInfo'], {
          keywords: newParams['keywordInfo']['keywords'].split(',')
        });
      } else {
        delete newParams['keywordInfo']['keywords'];
      }

      if (newParams['saleStatus'] && newParams['saleStatus']['isAll'] === false) {
        Object.assign(newParams['saleStatus'], {
          types: newParams['saleStatus']['types'].split(',')
        });
      }

      if (newParams['saleSettingStatus'] && newParams['saleSettingStatus']['isAll'] === false) {
        Object.assign(newParams['saleSettingStatus'], {
          types: newParams['saleSettingStatus']['types'].split(',')
        });
      }

      if (newParams['customPropertyValueNos']) {
        Object.assign(newParams, {
          customPropertyValueNos: newParams['customPropertyValueNos'].split(',').map((no: string): number => Number(no))
        });
      }

      if (isAllSave) {
        const data = JSON.parse(JSON.stringify(newParams));
        delete data.page;
        delete data.size;
        this.$api.postProductsSearchAllAtOnce({data} as any).then(({data}): void => {
          const list = data.filter((v: any): any => !this.noCheckMallProductNos.includes(v.mallNo));
          this.save(list, true);
        });
      } else {
        this.$api.postProductsSearch({data: newParams} as any).then(({data}): void => {
          this.searchRespones = Object.assign({}, data);
          this.gridProps.options.pageOptions.page = page;
          this.gridProps.options.pageOptions.perPage = Number(this.searchParams.size);
          this.gridProps.options.pageOptions.totalCount = 5;
          if (this.routeQuery['categoryCondition.no']) {
            this.$nextTick((): void => {
              this.searchRespones.contents.forEach((row: any): void => {
                if (row.displayCategoryNos.length <= 1) {
                  (this.$refs.itemTable as any).disableRowCheck(row.rowKey);
                }
              });
            });
          }
        });
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public save(mallProducts: any, noAlert: boolean = false): void {}

  public customCheckboxReset(): void {
    this.searchParams['customPropertyValueNos'] = '';
    (this.$refs.customCheckbox as any).innerCheckedNos = [];
  }

  public reset(): void {
    this.searchParams = {...this.searchParamsResetData};
    this.keywordTexthide = true;
    this.isCommissionTypeDisabled = false;
    this.isCommissionRateView = false;

    this.brandsInputVal = '';
    // this.searchParams['brandNo'] = -100;
    this.partnerInputVal = '';
    // this.searchParams['partnerNo'] = -100;
    this.adminInputVal = '';
    this.searchParams['adminNo'] = -100;
    this.customCheckboxReset();

    if (!this.displayCategoryNos.length) {
      this.categoiesCascade.initDepthData();
      this.getMallCategories();

      //this.displayCategoryNos.length === 1 => no handler!
    } else if (this.displayCategoryNos.length > 1) {
      this.categoiesCascade.categoryNo = '';
    }
    this.initSaleStatus();
    this.incomingCheckedNos = [];

    (this.$refs.productPopSearch as any).showCustomProperty = true;
    this.invalidKeywordSwitch = false;
    this.invalidKeywordText = '';
    this.invalidKeywordClass = '';
  }

  public setCustomProperty(propertyNos: string[]): void {
    this.searchParams['customPropertyValueNos'] = propertyNos.join(',');
  }

  public setDescription(): void {
    if (this.routeQuery.hideDesc === 'true') {
      return;
    }

    const descId = this.routeQuery.description ? `${this.routeQuery.description}` : 'searchPopupDescription';
    const target = window.opener && window.opener.document.getElementById(descId);
    if (target) {
      const productPopSearch = this.$refs.productPopSearch as any;
      productPopSearch.noticeBoxHTML = target.innerHTML;
      productPopSearch.isShowNoticeBox = true;
    }
  }

  public toggleCustomProperty(): void {
    if (this.routeQuery.customProperty === 'true') {
      (this.$refs.productPopSearch as any).showCustomProperty = false;
    }
  }

  public showCustomPropertyArea(): void {
    if (this.routeQuery.customProperty === 'true') {
      (this.$refs.productPopSearch as any).isExistcustomProperty = true;
    }
  }

  public getCustomProperty(): void {
    // ?if exsit the custompropery nos, open it
    // const customPropertyValueNos = this.routeQuery.customProperty;
    // if (customPropertyValueNos) {
    //   Object.assign(this.searchParams, { customPropertyValueNos });
    //   this.incomingCheckedNos = customPropertyValueNos.split(',') as any;
    // }
    this.$api.getCustomPropertyUsable().then(({data}): void => {
      this.customProperties = data.filter((item: any): boolean => item.used);
    });
  }

  public saleStatusType(): void {
    const reverseProduct = this.routeQuery.reverse === 'true';
    if (reverseProduct) {
      this.saleDisabledData = ['PROHIBITION_SALE'];
    }
  }

  public promotion(): void {
    if (this.routeQuery.coupon === 'true' || this.routeQuery.additionalDiscount === 'true') {
      this.promotionYnDisable = true;
      this.searchParams.allowsPromotion = 'Y';
      this.searchParamsResetData.allowsPromotion = 'Y';
    }
  }

  public initSaleStatus(disabled: boolean = false, checked: boolean = true): void {
    this.isAllDisabled = disabled;
    if (checked) {
      this.saleStatusData = ['ON_PRE_SALE', 'WAITING_SALE', 'ON_SALE', 'END_SALE'];
      this.saleSettingStatusData = ['AVAILABLE_FOR_SALE', 'STOP_SELLING', 'PROHIBITION_SALE'];
    } else {
      this.saleStatusData = [];
      this.saleSettingStatusData = [];
    }

    this.saleStatusType();
  }

  public categoriesDataHandle(array: []): CategroyType[] {
    if (array.length) {
      return array.map(
        (item: any): CategroyType => {
          const value = item.displayCategoryNo || item.categoryNo;
          const label = item.displayCategoryName || item.name;
          const children = this.categoriesDataHandle(item.children || item.child);
          return {value, label, children};
        }
      );
    } else {
      return [];
    }
  }

  public displayCategoryFindByNo(displayCategorys: [], displayCategoryNo: number): any {
    // let txt = '';
    let found = false;
    let result = {};
    function deepFind(data: any, toFindNo: number, displayName: string = ''): void {
      for (let i = 0, l = data.length; i < l; i++) {
        const {displayCategoryNo, depth, displayCategoryName, children} = data[i];
        let txt = displayName;
        if (txt) {
          txt += '>' + displayCategoryName;
        } else {
          txt = displayCategoryName;
        }

        if (displayCategoryNo === toFindNo) {
          result = {displayCategoryNo, depth, displayCategoryName: txt};
          found = true;
          break;
        } else if (children.length) {
          deepFind(children, toFindNo, txt);
          if (found) {
            break;
          }
        }
      }
    }
    deepFind(displayCategorys, displayCategoryNo);
    return result;
  }

  public getMallCategories(): void {
    this.$api
      .getDisplayCategoriesTree({
        params: {
          mallNo: Number(this.routeQuery['mallNo'])
        }
      })
      .then(({data}: any): void => {
        if (this.displayCategoryNos.length) {
          this.displayCategoryNos.forEach((categoryNo: any): void => {
            this.displayCategoryArray.push(this.displayCategoryFindByNo(data, categoryNo));
          });
          if (this.displayCategoryArray.length === 1) {
            Object.assign(
              this.searchParams,
              {'categoryCondition.depth': this.displayCategoryArray[0]['categoryCondition.depth']},
              {'categoryCondition.no': this.displayCategoryArray[0]['categoryCondition.no']}
            );
            Object.assign(
              this.searchParamsResetData,
              {'categoryCondition.depth': this.displayCategoryArray[0]['categoryCondition.depth']},
              {'categoryCondition.no': this.displayCategoryArray[0]['categoryCondition.no']}
            );
          }
        } else {
          this.categoiesCascade.setDepthData(1, this.categoriesDataHandle(data));
        }
      });
  }

  public commissionRateKeyup(e: any): void {
    const {
      target: {value, id, valueAsNumber, validationMessage}
    } = e;

    if (valueAsNumber === NaN || validationMessage.length) {
      this.searchParams[id] = '';
      e.target.value = '';
    } else if (value.length > 4) {
      this.searchParams[id] = value.substr(0, 4);
    }
  }

  public commissionRateChange(e: any): void {
    let {value, id} = e.target;
    if (!value.trim()) {
      this.searchParams[id] = '';
      return;
    } else {
      value = value - 0;
      if (value > 100) {
        this.searchParams[id] = '100';
      } else if (value < 0) {
        this.searchParams[id] = '0';
      }

      const min = this.searchParams['commission.range.min'];
      const max = this.searchParams['commission.range.max'];

      if (typeof min !== 'undefined' && typeof max !== 'undefined' && min - 0 > max - 0) {
        alert(this.toI18n('MMINIMUM_VALUE_CANNOT_BE_GREATER')); //최소값이 최대값보다 클 수 없습니다.
        this.searchParams[id] = '';
      }
    }
  }

  public close(): void {
    window.close();
  }

  public init(): void {
    this.promotion();
    this.getCustomProperty();
    this.initSaleStatus();
    this.getMallCategories();
  }

  public async created(): Promise<any> {
    this.setPopIsExist(true);
    document.body.classList.add('popup');
    Object.assign(this.routeQuery, this.$route.query);
    Object.assign(
      this.searchParams,
      {mallNos: this.routeQuery.mallNo},
      {'categoryCondition.depth': this.routeQuery['categoryCondition.depth']},
      {'categoryCondition.no': this.routeQuery['categoryCondition.no']}
    );
    Object.assign(this.searchParamsResetData, {mallNos: this.routeQuery.mallNo});

    if (this.routeQuery['brandNo'] && this.routeQuery.coupon === 'true') {
      Object.assign(this.searchParams, {brandNo: this.routeQuery['brandNo']});
      Object.assign(this.searchParamsResetData, {brandNo: this.routeQuery['brandNo']});
      this.brandsInputVal = this.routeQuery['brandName'];
      this.isBrandDisable = true;
    }

    if (this.routeQuery['partnerNo'] && this.routeQuery.coupon === 'true') {
      Object.assign(this.searchParams, {partnerNo: this.routeQuery['partnerNo']});
      Object.assign(this.searchParamsResetData, {partnerNo: this.routeQuery['partnerNo']});
      this.partnerInputVal = this.routeQuery['partnerName'];
      this.isPartnerDisable = true;
    }

    const configurations = await getProductsConfigurationsByAllMall();
    const someConfig = configurations.find(({mallNo}: any): any => mallNo + '' === this.routeQuery.mallNo);
    this.productDetailUrl = someConfig ? someConfig.productDetailUrl : '';

    this.init();
  }
  public mounted(): void {
    this.initSaleStatus();
    this.categoiesCascade = this.$refs.categoiesCascade as any;
    this.saleStatusTypeCheckBox = this.$refs.saleStatusTypeCheckBox as any;
    this.showCustomPropertyArea();
    this.setDescription();
    this.$nextTick((): void => {
      this.search();
    });
  }
}
